export const social = {
  facebook: 'https://www.facebook.com/people/Onlysales/100077584538386',
  linkedin: 'https://www.linkedin.com/company/onlysalesofficiel',
}